// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__NonCt","aboutSec":"About_aboutSec__1rd1M","aboutImg":"About_aboutImg__1HnVh","aboutDes":"About_aboutDes__3othS","listElement":"About_listElement__3JOXj"};